module.exports = __webpack_public_path__ + "img/1440.1feaf4f1.svg";